<template>
  <div class="examSign borderBox">
    <!-- <div class="container-banner">
      <img class="icon-bg" src="../../static/images/examSign/img_bg.png" alt="" srcset="" />
      <img class="icon-lines" src="../../static/images/examSign/img-lines@2x.png" alt="" srcset="" />
      <span class="title">考级报名</span>
    </div> -->
    <div class="examSign-content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" :finished-text="finishedText" @load="getPage()">
          <!-- <div v-for="(item, i) in page.list" :key="i" @click="toExamSign(item)" class="list-item" :class="{ 'linear-blue': i%2 == 1, 'linear-red': i%2 == 0 }">
            <div class="item-title">
              <div class="f36 item-title-tip txt-el2 fff nowrap-2">{{item.batchName}}</div>
              <div class="f22 item-title-btn">{{item.countDownTime> 0 ? '等待报名': '正在报名'}}</div>
            </div>
            <img class="item-img" :src="item.batchImageUrl"/>
          </div> -->
          <div v-for="(item, i) in page.list" :key="i" @click="toExamSign(item)" class="list-item" :class="{ 'card-coffee': item.countDownTime > 0, 'card-blue': item.countDownTime <= 0 }">
            <div class="item-header">
              <div class="prefix"><span></span></div>
              <div class="title">{{item.countDownTime > 0 ? '报名未开始': '正在报名'}}</div>
              <div class="suffix"><span></span></div>
            </div>
            <div class="item-wrapper">
              <div class="title">{{item.batchName}}</div>
              <!-- <div class="time">
                <p>
                  <span class="label">报名开始时间</span>
                  <span>{{item.enrollStartTime}}</span>
                </p>
                <p>
                  <span class="label">结束结束时间</span>
                  <span>{{item.enrollEndTime}}</span>
                </p>
              </div> -->
              <div class="time">
                <p>
                  <span class="label">报名开始时间</span>
                  <span>{{$moment(item.enrollStartTime).format('YYYY.MM.DD HH:mm')}}</span>
                </p>
                <p>
                  <span class="label">报名结束时间</span>
                  <span>{{$moment(item.enrollEndTime).format('YYYY.MM.DD HH:mm')}}</span>
                </p>
              </div>
              <img class="img-bg" v-if="item.countDownTime > 0" src="../../static/images/examSign/img-bm-no.png" alt="">
              <img class="img-bg" v-else src="../../static/images/examSign/img-bm-yes.png" alt="">
            </div>
          </div>
          <!-- <div v-if="!loading" @click="toImagePreview" class="list-item linear-green">
            <div class="item-title">
              <div class="f36 item-title-msg fff">流程说明</div>
              <div class="f22 item-title-msg">在线考级的详细说明</div>
              <div class="f22 item-title-btn">查看详情</div>
            </div>
            <img class="item-img" src="../../static/images/examSign/img_logo3.png"/>
          </div> -->
        </van-list>
      </van-pull-refresh>
      <van-empty class="empty" v-if="!page.list.length && finished" :image="require('../../static/images/news/icon_kong_wuneirong.png')" description="没有更多内容了"/>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar title="请选择地区" :columns="areaList" @cancel="showPicker = false" @confirm="onConfirm"/>
    </van-popup>
  </div>
</template>
<script>
import { Picker, Popup, Icon, PullRefresh, List, Empty, Toast, ImagePreview } from 'vant'

export default {
  components: {
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Icon.name]: Icon,
    [Empty.name]: Empty,
  },
  data () {
    return {
      areaList: [],
      showPicker: false,
      batchId: undefined,
      finishedText: '没有更多内容了...',
      newsList: [],
      loading: false,
      finished: false,
      refreshing: false,
      totalPage: 1,
      queryParam: { pageNum: 1, pageSize: 10 },
      page: { pageSize: 10, pageNum: 1, list: [] }
    }
  },
  async mounted () {
    await this.getNewsList()
    await this.getAllAreaList2()
  },
  methods: {
    toImagePreview () {
      ImagePreview(['https://zego-davinci-public.oss-cn-shanghai.aliyuncs.com/test/dpm/exam_instructions.png'])
    },
    async onRefresh () {
      try {
        this.finished = false
        this.loading = true
        await this.getPage({ pageNum: 1 })
      } catch (e) {
        this.loading = false
        this.finished = true
        this.Tool.doError(e)
      }
    },
    async getPage (queryParam) {
      this.Tool.debounce('examSign-page', async () => {
        try {
          if (this.refreshing) {
            this.page.list = []
            this.refreshing = false
          }
          this.queryParam = Object.assign({}, this.queryParam, queryParam)
          let res = await this.$HTTP.ApiExamSign.enrollBatchPagePOST(this.queryParam)
          let page = res.data
          if (page && page.list && page.list.length && this.queryParam.pageNum > 1) {
            page.list = [...this.page.list, ...page.list]
          }
          if (page && page.list && page.list.length >= page.total) {
            this.finished = true
          } else if (this.Tool.isNull(page.list)) {
            this.finished = true
          } else if (this.Tool.isNull(page)) {
            this.finished = true
          }
          this.loading = false
          this.queryParam.pageNum = this.queryParam.pageNum + 1
          this.page = page
          this.$forceUpdate()
        } catch (e) {
          this.loading = false
          this.finished = true
          this.Tool.doError(e)
        }
      })
    },
    async getNewsList () {
      const { data } = await this.$HTTP.ApiArticle.articlePageForH5POST({ model: 3, pageNum: 1, pageSize: 2 })
      this.newsList = data.list
    },
    async toExamSign (val) {
      Toast.loading({ duration: 0, forbidClick: true, message: '' })
      const res = await this.$HTTP.ApiCommon.getUserInfoGET()
      this.$store.commit('setCurrentUserInfo', res.data)
      const currentTime = await this.$HTTP.ApiCommon.getCurrentTimeGET()
      Toast.clear()
      if (this.$moment(currentTime.timeMillis) >= this.$moment(val.enrollStartTime)) {
        this.batchId = val.batchId
        this.$router.push(`/exam-sign/user-edit?batchId=${this.batchId}`)
        
        // 音协考试需要先选择地区 this.onSelectPicker()
      } else {
        Toast('您报名的考试暂未开始，请耐心等待')
      }
    },
    toDetail (newsId) {
      this.$router.push(`/list/detail?newsId=${newsId}`)
    },
    toNewsPage () {
      this.$router.push(`/list?model=3`)
    },
    onConfirm (value, index) {
      this.showPicker = false
      const areaId = this.areaList[index[0]].children[index[1]].areaId
      this.Tool.setStorage('user-edit-info', {})
      this.$router.push(`/exam-sign/user-edit?batchId=${this.batchId}&areaId=${areaId}`)
    },
    onSelectPicker () {
      this.showPicker = true
    },
    async getAllAreaList2 () {
      const localData1 =
        this.$utils.$localStorage.get('arr2Areas') || undefined
      if (localData1) {
        this.areaList = localData1
      } else {
        // 选两级省市区联动
        let area = this.$utils.$localStorage.get('arr1Areas') || undefined
        if (!area) {
          const datas = await this.$HTTP.ApiCommon.getListAreaGET()
          area = datas.data
        }
        const localData1 = area.filter((v) => {
          return (
            v.areaName !== '华侨' &&
            v.areaName !== '国际' &&
            v.areaName !== '台湾' &&
            v.areaName !== '香港特别行政区' &&
            v.areaName !== '澳门特别行政区'
          )
        })
        this.$utils.$localStorage.set('arr1Areas', JSON.parse(JSON.stringify(localData1)))
        const cityArr = localData1.map((v) => ({ ...v, text: v.areaName }))
        let arr1 = cityArr.filter((v) => v.areaType == 1)
        let arr2 = cityArr.filter((v) => v.areaType == 2)
        let arr3 = cityArr.filter((v) => v.areaType == 3)
        let arr4 = this.transFormArea(arr1, arr3)
        this.areaList = this.transFormArea(arr4, arr2).map((v) => {
          let item = v
          if ('children' in v) {
            item = { ...v }
          } else {
            item = { ...v, children: [{ text: '', areaId: v.areaId }] }
          }
          return item
        })
        // 过滤只有湖北省的省份
        // this.areaList = this.areaList.filter(
        //   (v) => v.areaId == 'Mkoe75e110a13c926624a75a7b528f0e5fc5'
        // )
        this.$utils.$localStorage.set('arr2Areas', JSON.parse(JSON.stringify(this.areaList)))
      }
    },
    // 将一维地区数组转换成多维地区数组
    transFormArea (parentArr, childArr) {
      const res = parentArr.map((v) => {
        const arr = childArr.filter((k) => k.parentId == v.areaId)
        if (arr.length) {
          v.children = childArr.filter((k) => k.parentId == v.areaId)
        }
        return v
      })
      return res
    }
  }
}
</script>
<style lang="less" scoped>
  .examSign {
    width: 100vw;
    height: 100%;
    background: #fff;
  }
  .container-banner {
    position: relative;

    .icon-bg{
      display: block;
      width: 100vw;
      height: 170px;
    }

    .icon-lines {
      height: 78px;
      width: 210px;
      position: absolute;
      left: 50%;
      bottom: 30px;
      transform: translateX(-50%);
    }

    .title {
      display: block;
      position: absolute;
      left: 50%;
      bottom: 46px;
      width: 135.5px;
      height: 46px;
      transform: translateX(-50%);
      font-size: 32px;
      font-family: 'Source Han Serif CN';
      font-weight: 800;
      line-height: 46px;
      color: #F8E7D2;
      opacity: 1;
    }
  }

  .examSign-content {
    margin-top: 28px;
    position: relative;
    width: 100%;
    // height: calc(100vh - 170px);
    height: 100vh;
    margin-top: 0;
    padding: 20px;
    background: #fff;
    overflow-y: auto;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    &-news {
      width: 100%;
      // padding: 16px;
      box-shadow: 0px 0px 8px rgba(9, 5, 78, 0.1);
      border-radius: 8px;
      margin-bottom: 20px;
      border: 1px solid #AA0405;
      overflow: hidden;

      .news-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #AA0405;
        padding: 16px;

        .news-blod {
          display: flex;
          align-items: center;
          color: #fff;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          vertical-align: middle;
        }

        .news-more {
          display: flex;
          align-items: center;
          color: #fff;
          font-size: 12px;
          font-family: PingFang SC;
        }

        .icon-new {
          width: 20px;
          height: 20px;
          margin-right: 8px;
        }

        .icon-more {
          width: 12px;
          height: 12px;
          margin-left: 5px;
        }
      }

      .news-item {
        // display: flex;
        // align-items: center;
        padding: 16px 16px;
        color: #001236;
        font-size: 13px;
        font-family: PingFang SC;

        .news-new {
          padding: 0 3px;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(255, 98, 98, 1);
          border-radius: 1px;
          color: #ff6262;
          font-size: 10px;
          margin-right: 3px;
        }
      }

      .bd1 {
        border-bottom: 1px solid rgba(217, 217, 217, 1);
      }

      .no-contaner {
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        font-family: PingFang SC;
        color: #c9ccd6;
      }

      .no-icon {
        width: 18px;
        height: 18px;
      }
    }
  }

  .list-item {
    width: 100%;
    height: 286px/2;
    border-radius: 12px/2;
    margin-bottom: 50px/2;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    opacity: 1;
    font-family: Source Han Serif CN;
    // box-shadow: 0px 2px/2 32px/2 rgba(0, 18, 54, 0.08);
    .item-header {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-top: 14px/2;
      flex: 1;
      opacity: 1;

      .title {
        height: 37px/2;
        line-height: 37px/2;
        margin: 0 14px/2;
        letter-spacing: 4px/2;
        font-size: 24px/2;
        font-family: 'SourceHanSerifCN-Bold';
        font-weight: 500; 
        color: #F8E7D2;
      }

      .prefix {
        height: 37px/2;
        line-height: 37px/4;
        span {
          display: inline-block;
          width: 112px/2;
          height: 2px/2;
          background: linear-gradient(270deg, #F8E7D2 0%, rgba(248, 231, 210, 0) 100%);
          opacity: 1;
        }
      }

      .suffix {
        height: 37px/2;
        line-height: 37px/4;
        span {
          display: inline-block;
          width: 112px/2;
          height: 2px/2;
          background: linear-gradient(90deg, #F8E7D2 0%, rgba(248, 231, 210, 0) 100%);
          opacity: 1;
        }
      }
    }

    .item-wrapper {
      position: relative;
      display: flex;
      flex-direction: column;
      height: 224px/2;
      background-color: #FFFFFF;
      border: 2px/1 solid #77573A;
      opacity: 1;
      border-radius: 12px/2;

      .title {
        margin-top: 36px/2;
        height: 57px/2;
        padding: 0 14px/2;
        text-align: center;
        font-family: 'SourceHanSerifCN-Bold';
        font-size: 40px/2;
        font-weight: bold;
        line-height: 57px/2;
        color: #260E09;
        opacity: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .time {
        margin-top: 15px/2;
        p {
          text-align: center;
          font-size: 26px/2;
          font-family: 'PingFang SC';
          font-weight: 400;
          line-height: 40px/2;
          color: #908581;
          opacity: 1;

          .label {
            margin-right: 16px/2;
          };
        }
      }

      .img-bg {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 349px/2;
        height: 73px/2;
      }
    }
  }

  

  .item-title {
    flex: 1;
    padding: 35px/2 20px/2 35px/2 40px/2;
  }

  .item-title-tip {
    font-weight: 500;
    height: 50px;
    line-height: 25px;
  }

  .item-title-msg {
    color: #fff;
  }

  .item-title-btn {
    margin-top: 27px/2;
    width: 150px/2;
    height: 40px/2;
    line-height: 40px/2;
    text-align: center;
    background: rgba(255, 255, 255, 1);
    border-radius: 100px/2;
    font-size: 11px;
  }

  .item-img {
    width: 224px/2;
    height: 224px/2;
    object-fit: contain;
  }

  .linear-red {
    background: linear-gradient(136deg,
    rgba(255, 144, 161, 1) 0%,
    rgba(255, 112, 134, 1) 100%);
  }

  .card-coffee {
    background-color: #E1C199;
    .item-wrapper {
      border: 2px/1 solid #E1C199;
    }

    .prefix {
      span {
        background: linear-gradient(270deg, #77573A 0%, rgba(119, 87, 58, 0) 100%) !important;
      }
    }

    .suffix {
      span {
        background: linear-gradient(90deg, #77573A 0%, rgba(119, 87, 58, 0) 100%) !important;
      }
    }
    .title {
      color: #77573A !important;
    }
  }
  .card-blue {
    background-color: #2E59A7;
    .item-wrapper {
      border: 2px/1 solid #2E59A7;
    }
  }

  .linear-blue {
    background: linear-gradient(134deg,
    rgba(56, 186, 255, 1) 0%,
    rgba(56, 124, 255, 1) 100%);
  }

  .linear-yellow {
    background: linear-gradient(134deg,
    rgba(252, 185, 67, 1) 0%,
    rgba(253, 153, 31, 1) 100%);
  }

  .linear-green {
    background: linear-gradient(315deg, #899cfe 0%, #4e61fd 100%);
  }
</style>
<style>
  .van-image-preview .van-image-preview__image {
    overflow: auto !important;
  }

  .van-image-preview .van-image__img {
    height: auto !important;
  }
</style>
